module.exports = "/public/images/6da9877336d2c883c632fb7fd33939f1.png";